var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconExtendedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 1.77778C10.6667 2.43581 10.3092 3.01033 9.77778 3.31772V4.44444H14.8889C15.9935 4.44444 16.8889 5.33988 16.8889 6.44444V8C17.3798 8 17.7778 8.39797 17.7778 8.88889V10.6667C17.7778 11.1576 17.3798 11.5556 16.8889 11.5556V14C16.8889 15.1046 15.9935 16 14.8889 16H2.88889C1.78432 16 0.888889 15.1046 0.888889 14V6.44445C0.888889 5.33988 1.78432 4.44444 2.88889 4.44444H8V3.31772C7.46862 3.01033 7.11111 2.43581 7.11111 1.77778C7.11111 0.795938 7.90705 0 8.88889 0C9.87073 0 10.6667 0.795938 10.6667 1.77778ZM0.888889 8C0.397969 8 0 8.39797 0 8.88889V10.6667C0 11.1576 0.397969 11.5556 0.888889 11.5556V8ZM5.77778 7.11111C5.0414 7.11111 4.44444 7.70806 4.44444 8.44444C4.44444 9.18082 5.0414 9.77778 5.77778 9.77778C6.51416 9.77778 7.11111 9.18082 7.11111 8.44444C7.11111 7.70806 6.51416 7.11111 5.77778 7.11111ZM13.3333 8.44444C13.3333 9.18082 12.7364 9.77778 12 9.77778C11.2636 9.77778 10.6667 9.18082 10.6667 8.44444C10.6667 7.70806 11.2636 7.11111 12 7.11111C12.7364 7.11111 13.3333 7.70806 13.3333 8.44444ZM12.4444 11.5556H5.33333V12.3333C5.33333 12.8856 5.78105 13.3333 6.33333 13.3333H11.4444C11.9967 13.3333 12.4444 12.8856 12.4444 12.3333V11.5556Z",
    fill: "#03447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconExtendedBlue);
export default __webpack_public_path__ + "static/media/ai-icon-extended-blue.cd3380266b55e4aa16a894c709e537f8.svg";
export { ForwardRef as ReactComponent };